import { trackAdobeEvent } from './adobe';

const toolbarSaveConversion = 'sd:fta:toolbar-save';

export default function trackPdfDownload() {
  const content = window?.pageData?.content;
  if (content) {
    trackAdobeEvent('contentDownload', { content });
    trackAdobeEvent('conversionDriverClick', {
      conversionDriver: {
        name: toolbarSaveConversion,
      },
    });
  }
}
